import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditSummaryForm } from '../../../components/cv/forms/EditSummaryForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useUpdateProfile } from '../../../hooks/useProfileApi';

export default function EditSummaryWebScreen() {
  const { t } = useTranslation('seeker');
  const { profileRef } = useCVData();
  const updateProfile = useUpdateProfile();

  const handleSave = async () => {
    const p = profileRef.current;
    await updateProfile.mutateAsync({ headline: p.headline, summary: p.summary });
  };

  return (
    <WebEditPageShell title={t('cv.edit.summary')}>
      <EditSummaryForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
